import { signOut } from "next-auth/react";
import nProgress from "nprogress";

const logout = async () => {
    nProgress.start();

    await signOut({ callbackUrl: '/api/end-session' });
    
    // const issuer = process.env['NEXT_PUBLIC_OIDC_ISSUER'];
    // const clientId = process.env['NEXT_PUBLIC_OIDC_CLIENT_ID'];
    // const returnTo = window.location.origin + "/logged-out";

    // const endSessionEndpoint = `${issuer}/connect/logout`;

    // const params = new URLSearchParams({
    //     client_id: clientId,
    //     post_logout_redirect_uri: returnTo
    // } as Record<string, string>);

    // window.location.href = `${endSessionEndpoint}?${params.toString()}`;
}

export default logout;